
import React from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as adminActions from '../../actions/admin';
import * as registerActions from '../../actions/register';
import { connect } from "react-redux";
import AuthService from './../../utils/authService';
import withRouter from '../../utils/withRouter';

class SideSubMenu extends React.Component {

    constructor(props) {
        super(props);
        this.state = { expanded: false };
    }

    getMenuIcon = (name) => {
        let iconName;
        switch (name) {
            case 'Admin':
                iconName = 'mdi mdi-clipboard';
                break;
             case 'Control Log':
                iconName = 'mdi mdi-worker';
                break;
             case 'Register':
                iconName = 'mdi mdi-login';
                break;
            default:
                iconName = 'mdi mdi-minus';
        }
        return iconName
    }

    toggleExpand = (e) => {
        e.preventDefault();
        this.setState((prev) => ({ expanded: !prev.expanded }));
    }

    render() {
        const { expanded } = this.state;
        return (

            <li className={expanded ? 'active' : ''}>

                <a className="has-arrow waves-effect waves-dark" href={'#'} aria-expanded={expanded} onClick={this.toggleExpand}>
                    <i className={this.getMenuIcon(this.props.text)}></i>
                    <span className="hide-menu">{this.props.text}</span>
                </a>

                <ul aria-expanded={expanded} className={`collapse${expanded ? ' in' : ''}`}>

                    {this.props.menu.map(subitem =>
                        <li key={subitem.menuId}><Link to={ '/' + subitem.area + '/' + subitem.controller} onClick={() => { document.body.classList.remove('show-sidebar'); const icon = document.querySelector('.nav-toggler i'); if (icon) icon.className = 'mdi mdi-menu'; }}>{subitem.text}</Link></li>
                    )}

                </ul>

            </li>

        )

    }
}

class SideMenu extends React.Component {


    logout = (e) => {
         e.preventDefault();

        this.props.actions.logout();
        this.props.navigate('/');
    }

    closeSidebar = () => {
        document.body.classList.remove('show-sidebar');
        const icon = document.querySelector('.nav-toggler i');
        if (icon) icon.className = 'mdi mdi-menu';
    }

    handleSidebarMouseEnter = () => {
        // Desktop-only: on mobile, touch triggers mouseenter too and would break drawer state
        if (window.innerWidth < 768) return;
        if (document.body.classList.contains('mini-sidebar')) {
            document.body.classList.remove('mini-sidebar');
            document.body.classList.add('mini-sidebar-hover');
        }
    }

    handleSidebarMouseLeave = () => {
        if (window.innerWidth < 768) return;
        if (document.body.classList.contains('mini-sidebar-hover')) {
            document.body.classList.remove('mini-sidebar-hover');
            document.body.classList.add('mini-sidebar');
        }
    }
    

    onClick = (item) => {
        
        let r = Object.assign([], this.state.parents);
        r.forEach(e => {
            if (e.text === item)
                e.show = true
            else
                e.show = false
        });
        
        this.setState({
            parents: r
        })
    }

    
   
    render() {

        let userName = AuthService.getUserName();

        return (
        

            <aside className="left-sidebar show-sidebar" onMouseEnter={this.handleSidebarMouseEnter} onMouseLeave={this.handleSidebarMouseLeave}>
                <div className="scroll-sidebar">
                    <div className="sidebar-logo-area">
                        <Link to="/" onClick={this.closeSidebar}>
                            <img src="/assets/images/Logo_2.png" alt="Dashboard" className="sidebar-logo-img" />
                        </Link>
                    </div>
                    <div className="user-profile">
                        <div className="profile-img"> 
                            <img src="/assets/images/th.jpg" alt="homepage" className="dark-logo" />
                        </div>
                        <div className="profile-text"> 

                            <h5>{userName}</h5>
                            
                                
                            <a onClick={f => this.logout(f)} href="#" className=""  title="Logout"><i className="mdi mdi-power"></i></a>
                                
                       
                        </div>
                    </div>
                    <nav className="sidebar-nav">

                        <ul id="sidebarnav">

                            <li>
                                <Link className="waves-effect waves-dark" to="/" aria-expanded="false" onClick={this.closeSidebar}>
                                    <i className="mdi mdi-view-dashboard"></i>
                                    <span className="hide-menu">Dashboard</span>
                                </Link>
                            </li>
                            <li className="nav-devider"></li>

                            {this.props.parents.map((item, index) =>


                                <SideSubMenu key={item.menuId || 0} onClick={this.onClick} show={item.show}
                                menu={this.props.menu.filter(submenu => submenu.parentId == item.menuId & item.parentId != submenu.menuId)}
                                text={item.text} index={index}/>


                            )}

                        </ul>
                    </nav>
                    
                    
                </div>          
            </aside>

            );

    }
    
}

function mapStateToProps(state) {
   
    let all = state.menu.map(a => ({ ...a })); 
    let parents = [];
    parents = all.filter((parent) => parent.parentId == parent.menuId);
   
    return {
        menu: all,
        parents: parents
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({...registerActions, ...adminActions}, dispatch)
    };
}


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SideMenu));

